import { motion } from "framer-motion";

// Word deepens from a light readable blue to the deep logo blue as it enters view — and STAYS.
const wordVariants = {
  hidden: { color: "#9AC7F8", opacity: 0.35, y: 14 },
  show: {
    color: "#0B47B8",
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};

// Heading whose words come alive (light -> deep logo blue) as they scroll into view.
// Pass either `lines` (array of strings) or `text` (single string). `as` sets the tag (h1/h2/h3).
export const ScrollColorHeading = ({ lines, text, as = "h1", className = "", testId }) => {
  const Tag = motion[as] || motion.h1;
  const resolvedLines = lines?.length ? lines : text ? [text] : [];

  return (
    <Tag
      className={className}
      data-testid={testId}
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.4 }}
    >
      {resolvedLines.map((line, li) => (
        <span key={li} className="block">
          {line.split(" ").map((w, wi) => (
            <motion.span key={`${li}-${wi}`} variants={wordVariants} className="mr-[0.22em] inline-block">
              {w}
            </motion.span>
          ))}
        </span>
      ))}
    </Tag>
  );
};
